// !!!! - DO NOT MODIFY - !!!!
// THIS FILE IS DEPLOYED AUTOMATICALLY BY MATTv2.
//
//  Deployment info:
//    Updated at:     2021-05-20T09:53:31+00:00
//    Cause:          Manual deployment.
//    Deployment ID:  126236
//    Project:        188
//    Environment:    377 - master
//    MD5:            75972202e4ee482e7b05eecec801a5fc
//    Signature:      eyJpdiI6IkZ1NWZ1eUpCSFQzMEJFeG40bm9Ydmc9PSIsInZhbHVlIjoickJROGtTTHJSMU83OWRpYyswdEFjVlwvSXh4RlRwUFNkM0djS2FuUUd3T2d3dEl0ZVdDWmxjU0NDa284VzhoMlJDVDg3Z09weTFIckp4OHdoSjNubXNETEdzYXhOSFwvQnBCenlkbEYzdit3S0RrOWVBTFdJU09qU2thTmE1dDVNdWtjRVRIS0czNjJPeGlMc3FCRkJUVWJUMTRvYXVkRm5lWW1tdW9Cc1Q3UjlJU2loMVM1bFlTWHVyMDlCZGZqQ0ZkZStzOU5vakNnaXdUVSs5c2lUU2k3SmpVZ1N6ZVwvRHJncmREN3p0alZKRUlDTnVROVlOaTFURDAwdjBlMDdhQjJPcGZUREp5eHMrNVwvdStxeUhDOTR3eXhmZzhvQ1RUZVwvUEMwRlFqWWhHMkFIRUwweTFlZUtSdzdJMDhlTDhxV2tnS2FBc3M2NmpqcFExTjdnV1lrbTR2anNnMkVUWmw0ejdoSFNRY1ZIYzZPVm1jRXZmM0dHNldvN0E0NTBmY0Nhb29PTEl6Z0tzekNxaFBnZzdKcDRnPT0iLCJtYWMiOiJmYTNlZTQ1ZDRmNDZmOWY2ZTY5NDY3ZTE5NWE1ZjNkYmEzMWM2ZjYwZDg4M2I3YTNhYTgwNzgwN2ZhMTI0OWRlIn0=
// !!!! - DO NOT MODIFY - !!!!
// THIS FILE IS DEPLOYED AUTOMATICALLY BY MATTv2.
//
//  Deployment info:
//    Updated at:     2020-03-25T11:08:33+00:00
//    Cause:          Manual deployment.
//    Deployment ID:  66174
//    Project:        188
//    Environment:    377 - master
//    MD5:            ca1b547c6ee27248d6b36b6b598f5762
//    Signature:      eyJpdiI6InhuNUg3Y3UxRitWTmErKzg4MUFpZ1E9PSIsInZhbHVlIjoiYnFQeDk4WnFUSUNuTlI0ancrNFdyMlNqUmN1V09nUDdHTFU2MnRcL2VcL3N6eGN1akx1dE8yak91VWxOeFlqUVJqWnZ1V0VVSWJVQWtBTkx6OTRNcUVcL2swRThqeTJUM2szc3pKbGxOV2NxcXZWcEVsR2oxMXhXOTJQeERhdWtrMVhPVE16R0dKVWJTTDZYZjVNQkFBOXlZeEYydmgzUUxYYVZDMUxYVGlzTlQrRFJRVXc4bVZOcGdCVG54aWd0dHhSRW9nMWVnK1wveW5sUEJ3aVZKUDFVRXg5NmV1NHFaaktzcmdJXC95SGtDUGxZdDBtaDFseVVDWDVnZFFCTWZESjF1S3QzdklUTXFWbzQ5dmZDMnlORm8zYmlpMVAzMjNFeWYyaUt0eGozQjdhOUZCVnJJeE1pMnVmekNRbzV5bE1vZWthWHF0d3orNkQ3cU9NOEViT3lOSGRzR0tsU0hLdmhcL25cL200ZnZad3g0a3ZrU0Nac2RXK3R5ZTlURHZrUitBUyIsIm1hYyI6ImE5MDAxYzJhMzA5MjE1NTM3ZWEwN2VlMGZjYjlhM2Q2Y2NlNDY3ZWUwODkyZDg3ODg5MTFjNDkwOWMwOTA5ZDQifQ==
/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 */
/* TABS JS */
$(document).ready(function () {
  $(".tab-controls a").on("click", function (e) {
    e.preventDefault();

    // Remove active class from buttons
    $(".tab-controls a").removeClass("active");

    // Add the correct active class
    $(this).addClass("active");

    // Hide all tab items
    $("[class^=tab-item]").hide();

    // Show the clicked tab
    var num = $(this).data("tab-item");
    $(".tab-item-" + num).fadeIn();
  });
});
/*Monogram step form*/
if (localStorage.getItem('vstloc')) {
  var locknow = localStorage.getItem('vstloc');
  if (locknow == 'UK' || locknow == "US") {
  } else {
    var locknow = "ROW"
  }
  $('.location' + '.' + locknow).show();
} else {
  jQuery.ajax({
    url: 'https://api.ipstack.com/check?access_key=76d4a83235cd9edb435d3efb662ea8ff&fields=country_code',
    type: 'GET',
    dataType: 'jsonp',
    success: function (ipstack) {
      var locknow = localStorage.setItem('vstloc', ipstack.country_code);
      $('.location' + '.' + locknow).show();
      console.log('detecting');
    }
  });
}

jQuery(document).ready(function () {
  let isCenti = true;
  $('.convert-cm-in').click(function () {
    if (isCenti) {
      converTo('in');
      $(this).text('CM/IN')
      isCenti = false;
    } else {
      converTo('cm');
      $(this).text('CM/IN')
      isCenti = true;
    }
  });
  function converTo(scale) {
    var multiplier = 2.54;
    $('.measurement').each(function () {
      var newVal = parseFloat($(this).data('original'));
      newVal = scale === 'in' ? newVal / multiplier : newVal;
      newVal = newVal.toFixed(1);
      $(this).text(newVal);
      $(this).siblings('.scale').text((scale == 'in') ? 'in' : 'cm')

    });
  }
});



$(document).ready(function () {
  $(".open").on("click", function () {
    $(".popup-overlay, .popup-content").addClass("active");
  });
  $(".close").on("click", function () {
    $(".popup-overlay, .popup-content").removeClass("active");
  });
  $(".popup-overlay").on("click", function () {
    $(".popup-overlay, .popup-content").removeClass("active");
  });

});

/*
@require
Jquery: https://jquery.com/
jquery-cookie: https://github.com/carhartl/jquery-cookie
Allows you to set a discount code via a URL and pass into shopify checkout
https://myshopifystore.com?coupon=MYCOUPONCODE
can append ?coupon=MYCOUPONCODE to any URL
*/

// Get paramaters from the URL
function getParameterByName(name, url) {
  if (!url) {
    url = window.location.href;
  }

  name = name.replace(/[\[\]]/g, "\\$&");
  var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
    results = regex.exec(url);
  if (!results) return null;
  if (!results[2]) return '';
  return decodeURIComponent(results[2].replace(/\+/g, " "));
  console.log(url);
}

// This must be added to your checkout form
$discountInput = $('input.js-form-discount');
// set cookie with passed in coupon code to any URL
$coupon = getParameterByName('coupon');
console.log($coupon);
Cookies.set('discountCode', $coupon, { expires: 30, path: '' });
// Get cookie discount code value and set form value
$discountCode = Cookies.get('discountCode');
if ($discountCode != 'null') {
  $discountInput.val($discountCode);
} else {
  $discountInput.remove();
}


// popup.liquid
$(document).ready(function () {
  var $form = $('#newsletter-popup')
  if ($form.length > 0) {
    $('#mc-embedded-subscribe-popup').bind('click', function (event) {
      if (event) event.preventDefault()
      registerpop($form)
      console.log('click btn');
    })
  }
  console.log($form);
})

function registerpop($form) {
  $('#mc-embedded-subscribe').val('Sending...');
  $.ajax({
    type: $form.attr('method'),
    url: $form.attr('action'),
    data: $form.serialize(),
    cache: false,
    dataType: 'json',
    contentType: 'application/json; charset=utf-8',
    error: function (err) { alert('Could not connect to the registration server. Please try again later.') },
    success: function (data) {
      $('#mc-embedded-subscribe').val('subscribe')
      if (data.result === 'success') {
        // Yeahhhh Success
        console.log(data.msg)
        $('#first-step').hide();
        $('#second-step').show();
      } else {
        // Something went wrong, do something to notify the user.
        console.log(data.msg)
        $('#mce-EMAIL').css('borderColor', '#ff8282')
        $('#subscribe-result').css('color', '#ff8282')
        $('#subscribe-result').html('<p>' + data.msg.substring(4) + '</p>')
      }
    }
  })
};

$(document).ready(function () {
  if (localStorage.getItem('signup')) {
    var hide = localStorage.getItem('signup');
    console.log(hide);
    if (hide) {
      $('#step-one-footer').hide();
      console.log(hide);
    } else {
      $('#step-one-footer').show();
    }
  }
  var $form = $('#newsletter-footer')
  if ($form.length > 0) {
    $('#mc-embedded-subscribe-footer').bind('click', function (event) {
      if (event) event.preventDefault()
      register($form)
    })
  }
});
function register($form) {
  $('#mc-embedded-subscribe-footer').val('Sending...');
  $.ajax({
    type: $form.attr('method'),
    url: $form.attr('action'),
    data: $form.serialize(),
    cache: false,
    dataType: 'json',
    contentType: 'application/json; charset=utf-8',
    error: function (err) { alert('Could not connect to the registration server. Please try again later.') },
    success: function (data) {
      $('#mc-embedded-subscribe').val('subscribe')
      if (data.result === 'success') {
        // Yeahhhh Success
        $('#step-one-footer').hide();
        $('#step-second-footer').show();
        localStorage.setItem('signup', true);
      } else {
        // Something went wrong, do something to notify the user.
        console.log(data.msg)
        $('#mce-EMAIL').css('borderColor', '#ff8282')
        $('#subscribe-result-footer').css('color', '#ff8282')
        $('#subscribe-result-footer').html('<p>' + data.msg.substring(4) + '</p>')
      }
    }
  })
};


// size-chart.liquid
$('.data-table-arrow').click(function (e) {
  e.preventDefault();
  var dataTableDiv = $('#' + e.target.dataset["target"] + '>div');
  var scrollPos = $(dataTableDiv).scrollLeft();
  var width = $('#' + e.target.dataset["target"] + ' table').width();
  var maxScrollPos = width - 227;

  if (scrollPos < maxScrollPos) {
    $(dataTableDiv).scrollLeft(maxScrollPos);
    //  $(e.target).removeClass('arrow-right').addClass('arrow-left');
  } else {
    $(dataTableDiv).scrollLeft(0);
    //$(e.target).removeClass('arrow-left').addClass('arrow-right');
  }
});
$('.responsive-data-table div').on('scroll', function (e) {
  var dataTableDiv = $(this);
  var width = $(this).find('table').width();
  var maxScrollPos = width - 227;
  var scrollLeft = $(this).scrollLeft();
  console.log($(this).scrollLeft(), maxScrollPos);
  var arrow = $("#" + e.target.parentElement.dataset["arrow"]);
  if (scrollLeft == maxScrollPos) {
    $(arrow).removeClass('arrow-right').addClass('arrow-left');
    // Need to show scroll right

  } else {
    $(arrow).removeClass('arrow-left').addClass('arrow-right');
  }

});

// product.liquid
$('.show-section').on('click', function (e) {
  var data = $(e.target).data();
  var linkLook = $('#action-complete-the-look');
  var linkCs = $('#action-crsell-viewed-products');
  if (data.show == "shopify-section-complete-the-look") {
    $(linkLook).removeClass('in-active');
    $(linkCs).addClass('in-active');
  }
  if (data.show == "shopify-section-crsell-viewed-products") {
    $(linkLook).addClass('in-active');
    $(linkCs).removeClass('in-active');
  }
  $('#' + data.show).removeClass('shopify-section--hidden');
  $('#' + data.hide).addClass('shopify-section--hidden');
});

var screenWidth = $(window).width();

if (screenWidth <= 640) {
  $('.carousel-phone').on('scroll', function (e) {
    var scrollLeft = $(this).scrollLeft();
    var scrollItem = Math.floor(scrollLeft / screenWidth) + 1;
    var currentSlide = $(this).data('slide');
    if (currentSlide != scrollItem) {

      $(this).data('slide', scrollItem);
      $(this).parent().find('.dot.is-selected').removeClass('is-selected');
      $(this).parent().find('.dot:nth-of-type(' + scrollItem + ')').addClass('is-selected');
    }
  });
  $('.carousel-container').on('click', function (e) {
    if (e.target.className.indexOf('dot') >= 0) {
      var clickedSlide = $(this).find("li").index(e.target);
      var scrollOffset = clickedSlide * screenWidth;
      $(this).find('.carousel-phone').scrollLeft(scrollOffset);
    }
  })
}

/*
 * Sticky Add to Bag
 */
function enableStickyCta() {
  if( /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent) || screenWidth <= 640 ) {
    if ($('body').hasClass('template-product')) {
      var $cartBtn = $('.ProductForm .addtocart'),
          cartBtnOffset = $cartBtn.offset().top,
          cartBtnHeight = $cartBtn.outerHeight();

      var windowScroll = $(window).scrollTop(),
          windowHeight = $(window).height();

      if (windowScroll > cartBtnOffset - cartBtnHeight || windowScroll + windowHeight < cartBtnOffset + cartBtnHeight) {
        $('.ProductForm .addtocart.sticky_cta').removeClass('hidden');
      } else {
        $('.ProductForm .addtocart.sticky_cta').addClass('hidden');
      }
    }
  } else {
    $('.ProductForm .addtocart.sticky_cta').addClass('hidden');
  }
}

if( /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent) || screenWidth <= 640 ) {
  enableStickyCta();
  $(window).scroll(enableStickyCta);
}

$(window).resize(enableStickyCta);

$('.Modal--QuickAdd [data-inventory]').on('click', function (e) {
  var inventoryElem = e.target;
  var modalElem = $(e.target).parents('.Modal--QuickAdd');
  var cartElem = modalElem.find('.ProductForm__AddToCart');

  if (parseInt(inventoryElem.dataset.inventory) === 0) {
    cartElem.attr('disabled-cart', 'disabled');
    cartElem.html(cartElem.data('stock-false'));
    modalElem.find('.ProductForm__Variants').addClass("select-size");
  } else {
    cartElem.removeAttr('disabled-cart');
    cartElem.html(cartElem.data('stock-true'));
    modalElem.find('.ProductForm__Variants').removeClass("select-size");
  }
});

$('.QuickAdd__Form .ProductForm__AddToCart').on('click', function (e) {
  var attr = $(this).attr('disabled-cart');
  if (typeof attr !== 'undefined' && attr !== false) {
    return false;
  } else {
    $.ajax({
      type: 'POST',
      url: '/cart/add.js',
      dataType: 'json',
      data: $(e.target).parents('.QuickAdd__Form').serialize(),
      success: function (product) {
        document.dispatchEvent(new CustomEvent('product:added', {
          detail: {
            variant: product,
            quantity: 1
          }
        }));
        $(e.target).parents('.Modal--QuickAdd').find('.Modal__Close').trigger('click');
      }
    });
  }
});

$('.Modal.Modal--QuickAdd .ProductForm__AddToCart[disabled-cart]').on('click', function (e) {
  $(this).parent('.ProductForm__Variants').addClass("select-size");
});

$(".shopify-section--header .site-link.link-search").click(function() {
  document.querySelector('.snize-sticky-searchbox').click();
});

$(".snize-sticky-searchbox").click(function() {
  $(this).removeClass('snize-sticky-searchbox-opened');
});

jQuery(document).ready(function($) {
  if ($(window).width() >= 1240) {
    $(".grid_cell_full_item").each(function() {
      var mainElement =  $(this);
      var textHeight = 0
      var firstText = 0
      var secondText = 0
      mainElement.next().find(".product-grid-cell__item").each(function(idx) {
        if (idx == 2) {
          firstText = $(this).height() - $(this).find("card-images").height();
        } else if (idx == 3) {
          secondText = $(this).height() - $(this).find("card-images").height();
        }
      })
      textHeight = firstText > secondText ? firstText : secondText
      var elementHeight = mainElement.next().height() - textHeight;
      mainElement.find(".AspectRatio--tall").css("padding-top", elementHeight - 20 + 'px');
      elementHeight  = 0
      console.log(firstText, secondText, textHeight)
    })
  }

  $('.country-selector__footer-current').on('click', function(e) {
    $('.country-selector__popup').removeClass('visually-hidden');
  });
  $('.country-selector__current').on('click', function(e) {
    $(this).toggleClass('show-options');
  });

  $('.country-selector__list li').on('click', function(e) {
    const current = $('.country-selector__current').html();
    const currentlySelected = $(this).html();
    $(this).html(current);
    $('.country-selector__current').html(currentlySelected);
    $('.country-selector__current').removeClass('show-options');
  });

  $('.country-selector__btn').on('click', function(e) {
    if ( $('.country-selector__current').html() == '<img class="country-selector__flag" src="https://cdn.shopify.com/s/files/1/1327/6929/files/us.png?v=1635262791">United States&nbsp;($)' ) {
      window.location = 'https://asceno-us.myshopify.com/?redirect=1';
    } else {
      window.location = 'https://asceno-london.myshopify.com/?redirect=1';
    }
  });

  $('.Modal.Modal--QuickAdd').each(function() {
    $(this).css('top', '200%');
  });

  $('.PageOverlay').on('click', function() {
    $('.Modal.Modal--QuickAdd').each(function() {
      $(this).css('top', '200%');
    });
  })

  $('.Modal__Close').on('click', function() {
    $('.Modal.Modal--QuickAdd').each(function() {
      $(this).css('top', '200%');
    });
  })

  $('.ProductItem__QuickAddBtn').on('click', function() {
    $('.Modal.Modal--QuickAdd').each(function() {
      $(this).css('top', '50%');
    });
  });
});

$(document).ready(function() {
  $('.all-collections-carousel').flickity({
    draggable: true,
    arrowShape: { "x0": 10, "x1": 60, "y1": 50, "x2": 65, "y2": 45, "x3": 20 },
    pageDots: false,
    cellAlign: 'left'
  });

  $('.size__accordion__item .accordionItemHeading2').on('click', function() {
    $(this).next('.accordionItemContent').slideToggle();
    if (!$(this).parent().children(".accordionItemContent").hasClass("opened")) {
      $(this).parent().children(".accordionItemContent").addClass("opened");
      $(this).parent().children(".accordionItemHeading2").addClass("active");

    }
    else {
      $(this).parent().children(".accordionItemContent").removeClass("opened");
      $(this).parent().children(".accordionItemHeading2").removeClass("active");
    }
  })
})
